
// 参数字段说明：
export const fieldDesc: Record<string, string> = {
  physical_method: "物性计算方法",
  mode: "计算模式",
  phase: "相态",

  N: "塔板数",
  Ns: "进料位置",
  No: "出料位置",
  f: "流量",
  t: "温度",
  P_D: "塔顶压力",
  pressure_drop: "整塔压降",
  SPEC: "冷凝器类型",
  eff: "塔板效率",
  murphree: "是否使用Murphree效率",
  T_drop: "顶板过冷度",
  S1: "塔顶流股名称规定方式",
  S2: "规定方式 2",
  V1: "塔釜采出量",
  V2: "规定值 2",
  V_list: "气相采出信息列表",
  L_list: "液相采出信息列表",
  Q_list: "中段加热/冷却热量信息列表",
  max_iter_outer: "最大外层迭代次数",
  max_notimproved_count: "最大未改进迭代次数",
  max_inner_notconverged_count: "最大内层未收敛迭代次数",
  TOL: "收敛容差",
  im_mode: "稳健性策略编号",
  h: "时间松弛因子",
  D_col: "塔径",
  theta: "有效孔面积比",
  h_w: "堰高",
  C_v: "孔流系数",
  d_hole: "孔径",
  efficiency: "效率",
  hot_out_T: "热流股出口温度",
  UA: "传热系数和换热面积的乘积",
  output_f: "输出流量",
  deltaP: "压力变化",
  p: "入口压力",
  flow_type: "流向类型",
  cold_out_T: "冷流出口温度",
  cold_out_P: "冷流出口压力",
  hot_out_P: "热流出口压力",
};

// type中文名（查看计算参数用）
export const typeMap: Record<string, string> =
{
  "Flash2": "闪蒸罐",
  "Mixer": "混合器",
  "Splitter": "分流器",
  "RPlugReactor": "反应器",
  "ShellAndTubeExchanger": "管壳式换热器",
  "Pump": "泵",
  "DistilStrict": "精馏塔",
  "MultiStreamExchanger":"多流股换热器",
};

// type中文名（查看计算参数用）
export const typeMap2: Record<string, string> =
{
  "闪蒸罐": "Flash2",
  "闪蒸罐2": "Flash2",
  "混合器": "Mixer",
  "分流器": "Splitter",
  "分离器": "Splitter",
  "反应器": "RPlugReactor",
  "管壳式换热器": "ShellAndTubeExchanger",
  "泵": "Pump",
  "泵2": "Pump",
  "风机": "Pump",
  "精馏塔": "DistilStrict",
  "洗涤塔": "DistilStrict",
  "汽提塔": "DistilStrict",
  "洗油再生器": "ShellAndTubeExchanger",
  "换热器": "ShellAndTubeExchanger",
  "换热器2": "ShellAndTubeExchanger",
  "换热器3": "ShellAndTubeExchanger",
  "换热器4": "MultiStreamExchanger",
  "多流股换热器": "MultiStreamExchanger",
};

// type中文名（分组用）
export const typeMap3: Record<string, string> =
{
  "reactor": "反应器",
  "pump": "泵",
  "DistilStrict": "塔",
  "ShellAndTubeExchanger": "换热器",
  "Splitter": "分流器",
  "others": "阀门",
  "comments": "标注",
  "Flash2": "闪蒸罐",
  "Mixer":"混合器",
  "MultiStreamExchanger":"多流股换热器",
};
// 给输入参数的type中文名专用
export const typeMap4: Record<string, string> =
{
  "Flash2": "闪蒸罐",
  "Mixer": "混合器",
  "Splitter": "分流器",
  "RPlugReactor": "反应器",
  "ShellAndTubeExchanger": "管壳式换热器",
  "Pump": "泵",
  "DistilStrict": "塔",
  "MultiStreamExchanger":"多流股换热器",
};

// 查看计算参数所需字段信息（查看计算参数用）
export const fieldMap =
{
  elements:
  {
    // "name":{name:"操作单元名称",enum:{},unit:"",unitKey:""},
    // "type":{name:"操作单元类型",enum:{},unit:"",unitKey:""},
    "physical_method": { name: "物性计算方法", enum: { "NRTL": "NRTL", "SRK": "SRK" }, unit: "", unitKey: "" },
    "phase": { name: "相态", enum: { "L": "L-液相", "V": "V-汽相", "VL": "VL-汽液两相" }, unit: "", unitKey: "" },
    "mode": { name: "计算模式", enum: { "TP": "TP-温压闪蒸", "VP": "VP-汽化率压力闪蒸", "HP": "HP-压焓闪蒸" }, unit: "", unitKey: "" },
    "deltaP": { name: "压力变化", enum: {}, unit: "", unitKey: "" },
    "N": { name: "塔板数", enum: {}, unit: "", unitKey: "" },
    "P_D": { name: "塔顶压力", enum: {}, unit: "", unitKey: "p_unit" },
    "pressure_drop": { name: "整塔压降", enum: {}, unit: "", unitKey: "p_unit" },
    "SPEC": { name: "冷凝器类型", enum: { "Partial": "分凝器", "Total": "全凝器" }, unit: "", unitKey: "" },
    // "murphree":{name:"是否使用Murphree效率",enum:{0:"不使用",1:"使用"},unit:"",unitKey:""},
    // "T_drop":{name:"顶板过冷度",enum:{},unit:"",unitKey:""},
    // "S1":{name:"塔顶流股名称规定方式",enum:{"B":"塔底流量"},unit:"",unitKey:""},
    // "S2":{name:"规定方式",enum:{"L/D":"回流比","QC":"冷凝器热负荷"},unit:"",unitKey:""},
    "V1": { name: "塔釜采出量", enum: {}, unit: "", unitKey: "V1_unit" },
    "V2": { name: "规定值", enum: {}, unit: "", unitKey: "" }, //S2="L/D"=回流比;S2="QC"=冷凝器热负荷 J/mol
    "D_col": { name: "塔径", enum: {}, unit: "m", unitKey: "" },
    "theta": { name: "有效孔面积比", enum: {}, unit: "", unitKey: "" },
    "h_w": { name: "堰高", enum: {}, unit: "m", unitKey: "" },
    "C_v": { name: "孔流系数", enum: {}, unit: "", unitKey: "" },
    "d_hole": { name: "孔径", enum: {}, unit: "m", unitKey: "" },
    "UA": { name: "传热系数和换热面积的乘积", enum: {}, unit: "W/K", unitKey: "" },
    "flow_type": { name: "流向类型", enum: {}, unit: "", unitKey: "" },
    "efficiency": { name: "热效率", enum: {}, unit: "", unitKey: "" },
    "hot_out_T": { name: "热流出口温度", enum: {}, unit: "", unitKey: "t_unit" },
    "f": { name: "流量", enum: {}, unit: "", unitKey: "f_unit" },
    "t": { name: "温度", enum: {}, unit: "", unitKey: "t_unit" },
    "p": { name: "压力", enum: {}, unit: "", unitKey: "p_unit" },
  },
  streams:
  {
    "physical_method": { name: "物性计算方法", enum: { "NRTL": "NRTL", "SRK": "SRK" }, unit: "", unitKey: "" },
    "mode": { name: "计算模式", enum: { "TP": "TP-温压闪蒸", "VP": "VP-汽化率压力闪蒸", "HP": "HP-压焓闪蒸" }, unit: "", unitKey: "" },
    "phase": { name: "相态", enum: { "L": "L-液相", "V": "V-汽相", "VL": "VL-汽液两相" }, unit: "", unitKey: "" },
    "f": { name: "流量", enum: {}, unit: "", unitKey: "f_unit" },
    "t": { name: "温度", enum: {}, unit: "", unitKey: "t_unit" },
    "p": { name: "压力", enum: {}, unit: "", unitKey: "p_unit" },
  }
};

export const fieldMap2 =
{
  "操作单元名称": "name",
  "操作单元类型": "type",
  "物性计算方法": "physical_method",
  "相态": "phase",
  "计算模式": "mode",
  "压力变化": "deltaP",
  "塔板数": "N",
  "塔顶压力": "P_D",
  "整塔压降": "pressure_drop",
  "冷凝器类型": "SPEC",
  "是否使用Murphree效率": "murphree",
  "顶板过冷度": "T_drop",
  "塔顶流股名称规定方式": "S1",
  "规定方式": "S2",
  "塔釜采出量": "V1",
  "规定值": "V2",
  "塔径": "D_col",
  "有效孔面积比": "theta",
  "堰高": "h_w",
  "孔流系数": "C_v",
  "孔径": "d_hole",
  "传热系数和换热面积的乘积": "UA",
  "流向类型": "flow_type",
  "热效率": "efficiency",
  "热流出口温度": "hot_out_T",
  "热流出口压力": "hot_out_P",
  "冷流出口温度": "cold_out_T",
  "冷流出口压力": "cold_out_P",
  "流量": "f",
  "温度": "t",
  "压力": "p",
  "再沸器":"reboiler",
  "操作规范":"operatingSpecifications",
  "操作规范值":"operatingSpecificationsValue",
  "工艺名称":"equipment_description",
  "总高":"total_height",
  "壳体长度":"shell_length",
  "材质":"material",
  "腐蚀裕量":"corrosion_allowance",
  "塔板材质":"tray_material",
  "填料高度":"packing_total_height",
  "溢流类型":"overflow_type",
  "设计塔顶温度":"design_top_temperature",
  "设计塔底温度":"design_bottom_temperature",
  "设计塔顶压力":"design_top_pressure",
  "设计塔底压力":"design_bottom_pressure",
  "操作塔顶温度":"operation_top_temperature",
  "操作塔底温度":"operation_bottom_temperature",
  "操作塔顶压力":"operation_top_pressure",
  "操作塔底压力":"operation_bottom_pressure",
  "设计温度上限":"design_temperature_high",
  "设计温度下限":"design_temperature_low",
  "壁面粗糙度":"wall_roughness",
};

export const unitMap =
{
  "T": ["C", "K"],
  "P": ["MPa", "Kpa", "Pa", "bar", "atm"],
  "MC": ["mg/m³", "g/m³", "kg/m³"],
  "GFR": ["Nm³/h", "kmol/h", "mol/h", "kg/h"],
  "LFR": ["L/h", "m³/h", "kmol/h", "mol/h", "kg/h"],
  "MFR": ["kg/h", "kmol/h", "mol/h"],
};

export const materialsValueMap =
{
  "H2O": "1.0",
  "CH3OH": "0.0",
  "H2": "0.0",
  "CO": "0.0",
  "CO2": "0.0",
  "CH4": "0.0",
  "N2": "0.0",
  "NH3": "0.0",
  "HCN": "0.0",
  "H2S": "0.0",
  "COS": "0.0",
  "Ar": "0.0",
};

export const dataTypeMap =
{
  "f":"number",
  "t":"number",
  "p":"number",
  "P":"number",
  "type":"string",
  "N":"number",
  "P_D":"number",
  "pressure_drop":"number",
  "max_iter_outer":"number",
  "max_iter_inner":"number",
  "max_notimproved_count":"number",
  "max_inner_notconverged_count":"number",
  "TOL":"number",
  "INNER_TOL":"number",
  "im_mode":"number",
  "h":"number",
  "D_col":"number",
  "theta":"number",
  "h_w":"number",
  "C_v":"number",
  "d_hole":"number",
  "SPEC":"string",
  "V1":"number",
  "S2":"string",
  "V2":"number",
  "UA":"number",
  "flow_type":"string",
  "efficiency":"number",
  "cold_out_T":"number",
  "cold_out_P":"number",
  "hot_out_T":"number",
  "hot_out_P":"number",
  "stream_in_cold":"number",
  "stream_in_hot":"number",
  "stream_out_cold":"number",
  "stream_out_hot":"number",
  "streamAttribute":"string",
  "f_unit":"string",
  "vaporFraction":"number",
  "internalType":"string",
  "trayType":"string",
  "packingType":"string",
  "physical_method":"string",
  "phase":"string",
  "mode":"string",
  "reboiler":"string",
  "operatingSpecifications":"string",
  "operatingSpecificationsValue":"number",
  "equipment_description":"string",
  "total_height":"number",
  "shell_length":"number",
  "material":"string",
  "corrosion_allowance":"number",
  "tray_material":"string",
  "packing_total_height":"number",
  "overflow_type":"string",
  "design_top_temperature":"number",
  "design_bottom_temperature":"number",
  "design_top_pressure":"number",
  "design_bottom_pressure":"number",
  "operation_top_temperature":"number",
  "operation_bottom_temperature":"number",
  "operation_top_pressure":"number",
  "operation_bottom_pressure":"number",
  "design_temperature_high":"number",
  "design_temperature_low":"number",
  "wall_roughness":"number",
  "T_drop":"number",
  "murphree":"number"
};

export const childFieldMap = 
{
  "eff":
  {
    "start":{"name":"起始塔板","unitName":null},
    "end":{"name":"结束塔板","unitName":null},
    "value":{"name":"效率值","unitName":null},
    "spec":{"name":"特殊效率","unitName":null},
    "组分":{"name":"组分","unitName":null},
    "效率值":{"name":"效率值","unitName":null},
  },
  "stream_type":
  {
    "stream_in_cold":{"name":"冷流股入口","unitName":null},
    "stream_out_cold":{"name":"冷流股出口","unitName":null},
    "stream_in_hot":{"name":"热流股入口","unitName":null},
    "stream_out_hot":{"name":"热流股出口","unitName":null},
  },
};
